exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/_object-pie.js
// module id = 51
// module chunks = 0